export default __webpack_public_path__ + "static/media/picking-asset.9fc4894a.svg";